import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView, trackClick } from '../analytics';

/**
 * Reports page views on route change and tracks button/link clicks for GA4.
 * Mount once inside the router (e.g. in App).
 */
const GoogleAnalytics: React.FC = () => {
  const location = useLocation();

  // Page view on route change (SPA)
  useEffect(() => {
    const path = location.pathname + location.search;
    const title = document.title || 'Verit Compliance';
    pageView(path, title);
  }, [location.pathname, location.search]);

  // Global click tracking: buttons, links, elements with data-ga-label
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const interactive = target.closest('button, [role="button"], a[href], [data-ga-label]');
      if (!interactive) return;

      const el = interactive as HTMLElement;
      const label =
        el.getAttribute('data-ga-label') ||
        el.getAttribute('aria-label') ||
        (el.textContent || '').trim().slice(0, 100) ||
        el.tagName;
      if (!label) return;

      trackClick(`${location.pathname}: ${label}`);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [location.pathname]);

  return null;
};

export default GoogleAnalytics;
